<template>
	<div class="contatiner">
		<div class="bg1">
			<!-- <img class="order-title" :src="orderTitle"/> -->
			<span style="font-size: 26px;margin-top: 18%;display: inline-table;"> {{goodName}}</span>
		</div>
		<div class="flex-wrap">
			<!-- <div v-if="hasQuery && address" class="box" style="margin-top: -40px;margin-bottom: 24px;"> 
        <div class="label">您的收货地址</div>
        <div class="baidu-wrap">
          {{address}}
        </div>
        <div class="help">如需改地址  请联系微信：xiaobaikaoyan001</div>
      </div>
      <div v-if="hasQuery && no" class="box">
        <div class="label">讲义快递单号查询结果</div>
        <div class="phone-wrap">
          <span>物流单号：{{no}}</span>
          <div class="copy" @click="copy($event, no)">复制</div>
        </div>
        <div class="btn-query">
          <a class="a" :href="url">点我查询物流</a>
        </div>
      </div>
      <div v-if="hasQuery && !no" class="box">
        <div class="label">快递单号查询结果</div>
        <div class="text-wrap">
          <div class="text1">当前未发货，请耐心等待</div>
          <div class="text1">按顺序发货哦~</div>
        </div>
      </div> -->
			<van-loading v-if="loading" size="24px" vertical>加载中...</van-loading>
			<div class="box" style="margin-top: -40px;">
				<div v-if="!hasQuery">
					<div class="label">输入下单手机号立即兑换</div>
					<div class="phone-wrap">
						<span>手机号：</span>
						<input class="input" v-model="phone" />
					</div>
					<div class="btn-query" @click="query">立即兑换</div>
				</div>



				<div class="titleList" v-if="hasQuery">
					<!-- <van-divider>暂时没有兑换码</van-divider> -->
					<div>
						<div class="phone-wrap phone-weight">
							<span class="span1">名称</span>
							<span class="span2">兑换码</span>
							<span class="span3">操作</span>
						</div>
					</div>
					<div v-for="(detail, idx1) in detailList">
						<div class="phone-wrap phone-wrap-bai">
							<span class="span1">{{detail.key}}</span>
							<span class="span2">{{detail.val}}</span>
							<span class="span3 copyspan" @click="copy($event, detail.val)">复制</span>
						</div>

					</div>

				</div>
				<a v-if="hasQuery" class="btn-query btn-query-a" href="https://appgead5iob7930.h5.xiaoeknow.com/redeem_code/redeem_index">点击兑换</a>
				<!-- <a  class="btn-query btn-query-a" href="https://appGeAd5iob7930.h5.xiaoeknow.com/content_page/eyJ0eXBlIjoiMyIsInJlc291cmNlX3R5cGUiOjI1LCJyZXNvdXJjZV9pZCI6IiIsImFwcF9pZCI6ImFwcEdlQWQ1aW9iNzkzMCIsInByb2R1Y3RfaWQiOiJ0ZXJtXzYwMGU4OTUzNjU5NTdfU1p1R29NIiwicmVmX2lkIjoiIn0">查看课程</a> -->
				<div class="help"  style="text-decoration: underline;margin-top: 40px;" @click="show = true">无法兑换？联系客服</div>

				<!-- <div class="help" v-if="goodsId == 8">如果开通遇到任何问题，请私聊小白数学助手：xbaimaths01</div> -->

			</div>
			<div class="footer">
				<div>—— 研小白 ——</div>
				<div class="text">考研上岸，就选研小白</div>

			</div>
		</div>

		<van-overlay :show="show" @click="show = false">
			<div class="wrapper" @click="show = false">
				<!-- <div class="block" /> -->
				<img class="block" :src="kfWechat" />
			</div>
		</van-overlay>
	</div>
</template>

<script>
	import {
		Divider,
		Cell,
		CellGroup,
		Field,
		Image,
		Loading,
		Button,
		Notify,
		NoticeBar,
		Grid,
		GridItem,
		Toast,
		Icon,
		Overlay
	} from 'vant';
	import https from '../../https'
	import orderTitle from '../../../static/address-title.png'
	import kf_888003526 from '../../../static/kf_wechat/888003526.png'
	import kf_912946870 from '../../../static/kf_wechat/912946870.png'
	import kf_914132910 from '../../../static/kf_wechat/914132910.png'

	export default {
		components: {
			[Cell.name]: Cell,
			[Field.name]: Field,
			[CellGroup.name]: CellGroup,
			[Image.name]: Image,
			[Loading.name]: Loading,
			[Button.name]: Button,
			[Notify.name]: Notify,
			[NoticeBar.name]: NoticeBar,
			[Grid.name]: Grid,
			[GridItem.name]: GridItem,
			[Icon.name]: Icon,
			[Divider.name]: Divider,
			[Overlay.name]: Overlay,
		},
		data() {
			return {
				orderTitle,
				hasQuery: false,
				no: '',
				link: '',
				phone: '',
				goodsId: '',
				goodName: '小白兑换码查询',
				loading: false,
				address: '',
				detail: "",
				show:false,
				detailList: [],
				kfWechat: kf_888003526
			};
		},
		created() {
			const goodsId = this.$route.params && this.$route.params.id
			this.goodsId = goodsId || 3
			if (this.goodsId == 8) {
				this.goodName = '小白数学兑换码查询'
			} else if (this.goodsId == 10) {
				this.goodName = '小白英语兑换码查询'
			} else if (this.goodsId == 888003526) {
				this.goodName = '研小白复试开课系统'
			} else if (this.goodsId == 912946870) {
				this.goodName = '考研政治&英语全年通关系统班'
				this.kfWechat = kf_912946870
			} else if (this.goodsId == 914132910) {
				this.goodName = '调剂专属定制兑换码查询'
				this.kfWechat = kf_914132910
			} else {
				this.goodName = '小白兑换码查询'
			}
		},
		methods: {
			reInput() {
				this.hasQuery = false
				this.detail = []
				// this.phone = ''
			},
			query() {
				var that = this
				if (!that.phone) {
					Notify({
						type: 'warning',
						message: '手机号不能为空哦'
					});
					return
				}

				that.loading = true
				this.queryList(that.phone, that.goodsId)

				// https.fetchGet(`/api/logistics/record/find/${that.phone}?goodsId=${that.goodsId}`).then(res => {
				// 	var detail = res.data.data.detail
				// 	if (res.data && res.data.data && Object.keys(res.data.data).length > 0) {


				// 		console.log(JSON.parse(detail))
				// 		that.hasQuery = true
				// 		that.loading = false
				// 		that.detail = JSON.parse(detail)

				// 	} else {
				// 		that.loading = false
				// 		Notify({
				// 			type: 'warning',
				// 			message: '手机号不存在，请重新输入'
				// 		});
				// 		this.hasQuery = false
				// 		this.detail = []
				// 	}
				// }).catch(err => {
				// 	that.loading = false
				// 	Notify({
				// 		type: 'warning',
				// 		message: '当前人数过多，请稍后重试'
				// 	});
				// 	this.hasQuery = false
				// 	this.detail = []
				// })

			},
			queryList(phone, goodsId) {
				var that = this
				that.detailList = []
				https.fetchGet(`/api/logistics/record/findList/${phone}?goodsId=${goodsId}`).then(res => {
					debugger
					if (res.data.data && res.data.data.list && res.data.data.list.length > 0) {
						var list = res.data.data.list
						this.hasQuery = true
						this.loading = false
						list.forEach(d => {
							if (d.detail) {
								that.detailList = that.detailList.concat(JSON.parse(d.detail))
							}
						})
					} else {
						that.loading = false
						Notify({
							type: 'warning',
							message: '手机号不存在，请重新输入'
						});
						that.hasQuery = false
					}
				}).catch(err => {
					that.loading = false
					Notify({
						type: 'warning',
						message: '当前人数过多，请稍后重试'
					});
					that.hasQuery = false
				})
			},
			copy(e, value) {
				try {
					const input = document.createElement('textarea')
					input.value = value
					document.body.appendChild(input)
					input.select()
					document.execCommand('Copy')
					document.body.removeChild(input)
					// Toast.success('复制成功');
					var toastText = "复制成功,即将跳转·"
					const toast = Toast.loading({
					  // duration: 0, // 持续展示 toast
					  // forbidClick: true,
					  icon:"none",
					  message: toastText,
					});
					
					let second = 3;
					const timer = setInterval(() => {
					  second--;
					  if (second) {
						  toastText+='·'
					      toast.message = toastText;
					  } else {
					    clearInterval(timer);
						toastText="复制成功,即将跳转·"
					    // 手动清除 Toast
					    Toast.clear();
						window.location.href="https://appgead5iob7930.h5.xiaoeknow.com/redeem_code/redeem_index";
					  }
					}, 1000);
					
				} catch (e) {
					Toast.fail('复制失败');
				}

			},
			feedback() {
				https.fetchPostToken(`/api/logistics/feedback`, {
					content: '链接失效',
					type: '链接失效'
				}).then(res => {
					if (res.data && res.data.data) {
						Notify({
							type: 'success',
							message: '已反馈哦'
						});
					}
				}).catch(err => {
					Notify({
						type: 'warning',
						message: '反馈提交失败'
					});
					console.log(err)
				})

			},
		}
	};
</script>

<style scoped lang="less">
	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	.block {
		width: 220px;
		height: 220px;
		background-color: #fff;
	}

	.phone-weight {
		font-weight: bold;
		background-color: #FFF1D2 !important;
	}

	.titleList {
		border: 1px solid #FFE09C;

		.phone-wrap-bai {
			background-color: #fff !important;
			border-top: 1px solid #FFE09C;
		}

		.phone-wrap {
			height: 44px !important;
			margin: 0 !important;
			width: auto !important;
			padding: 0px !important;
			display: flex;
			font-size: 14px;

			.copyspan {
				color: #3F94FF;
			}

			>span {
				text-align: center;
			}

			.span1 {
				width: 30%;
				display: inline-block;
			}

			.span2 {
				width: 40%;
				display: inline-block;
			}

			.span3 {
				width: 30%;
				display: inline-block;
			}
		}
	}

	.titleList {
		margin: 30px 10px 0;
	}

	.van-loading--vertical {
		position: absolute;
		z-index: 9;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.contatiner {
		display: flex;
		flex-direction: column;
		min-height: 100vh;
		background: linear-gradient(to bottom, #FFF6E3, #FFE096);

		.bg1 {
			width: 100%;
			height: 32vh;
			background: url(../../../static/bg1.png);
			background-size: 100% 100%;
			text-align: center;
			;

			.order-title {
				width: 235px;
				height: 74px;
				margin-top: 40px;
			}
		}

		.flex-wrap {
			flex: 1;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.box {
				width: 92vw;
				background: rgba(255, 255, 255, 1);
				border-radius: 18px;
				margin: 0 auto;
				padding-bottom: 24px;

				.text-wrap {
					padding-bottom: 32px;

					.text1 {
						text-align: center;
						color: #929292;

						&:first-child {
							padding-bottom: 10px;
						}
					}
				}

				.label {
					margin: 0 auto;
					padding-top: 35px;
					padding-bottom: 36px;
					text-align: center;
					font-size: 18px;
					color: #333333;
				}

				.baidu-wrap {
					width: 290px;
					padding: 15px;
					margin: 0 auto;
					background: #F3F3F3;
					color: #333;
					font-size: 14px;
					line-height: 24px;
					text-align: center;

					.baidu {
						font-size: 15px;
					}

					.link {
						color: #0091FF;
						word-break: break-all;
					}
				}

				.phone-wrap {
					position: relative;
					display: flex;
					align-items: center;
					padding-left: 14px;
					width: 290px;
					height: 56px;
					margin: 0 auto;
					background: #F3F3F3;

					.copy {
						position: absolute;
						right: 24px;
						top: 50%;
						transform: translateY(-50%);
						color: #3F94FF;
						font-size: 16px;
					}

					.input {
						flex: 1;
						height: 100%;
						border-width: 0;
						padding-left: 8px;
						background: transparent;
					}
				}

				.btn-query-a {
					display: block;

				}

				.btn-query {
					width: 290px;
					height: 44px;
					margin: 0 auto;
					margin-top: 36px;
					line-height: 44px;
					text-align: center;
					background: linear-gradient(270deg, rgba(255, 95, 31, 1) 0%, rgba(255, 136, 68, 1) 100%);
					box-shadow: 0px 5px 9px 0px rgba(255, 153, 80, 0.46);
					border-radius: 22px;
					color: #ffffff;
					font-size: 18px;

					.a {
						color: #ffffff;
						font-size: 18px;
					}
				}

				.btn-copy {
					width: 156px;
					margin-top: 24px;
				}

				.feedback {
					font-size: 14px;
					padding-top: 20px;
					color: #FF6322;
					text-align: center;
				}
			}

			.footer {
				margin: 0 auto;
				padding-top: 24px;
				padding-bottom: 40px;
				text-align: center;
				color: #9A6A39;

				.text {
					padding-top: 8px;
					text-align: center;
					font-size: 12px;
				}
			}

		}

		.help {
			margin-top: 20px;
			text-align: center;
			font-size: 14px;
			color: #545454;
		}
	}
</style>
